<template>
    <a-layout style="min-height: 100vh">
        <global-header>
        </global-header>
        <a-layout-content class="bg-white">
          <router-view/>
        </a-layout-content>
        <global-footer>
        </global-footer>
    </a-layout>
</template>

<script>
import GlobalFooter from './GlobalFooter.vue'
import GlobalHeader from './GlobalHeader.vue'

export default {
    name: 'BasicLayout',
    components: {
        GlobalHeader,
        GlobalFooter
    }
}
</script>

<style>
  .bg-white {
    height: 100%;
    background-color: #fff;
  }
</style>
